import React, { useState, useEffect } from "react";
import Divider from "@material-ui/core/Divider";
import { Line, Pie } from "react-chartjs-2";
import axios from "axios";
import DashboardMerchant from "./DashboardMerchant";
import DashboardUsage from "./DashboardUsage";
import DashboardAsset from "./DashboardAsset";
import { Badge } from "react-bootstrap";

export default function Dashboard() {
  const [error, setError] = useState(false);





  const [lineData, setLineData] = useState({});
  const [chartData, setChartData] = useState({});
  const [chartData2, setChartData2] = useState({});
  const [totalEmployeeCount, setTotalEmployeeCount] = useState([]);
  const [totalUsageCount, setTotalUsageCount] = useState([]);

  const chart = () => {
    let empSal = [];
    let empAge = [];
    axios
      .get(`${process.env.REACT_APP_API_URL}dashboard/usageHistory`)
      .then((res) => {
        setError(false)
        for (let i = res.data.length - 1; i >= 0; i--) {
          empSal.push(parseInt(res.data[i].usageCount));
          var months = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ];

          empAge.push(months[res.data[i].month - 1]);
        }
        setLineData({
          labels: empAge,
          datasets: [
            {
              label: "Usage history",
              data: empSal,
              backgroundColor: ["#55ad88"],
              borderWidth: 4,
            },
          ],
        });
      }).catch(err => {
        setError(true)
      });
  };


  const chart2 = () => {
    const empChart1 = [];
    axios.get(`${process.env.REACT_APP_API_URL}dashboard`).then((res) => {
      const dataObj2 = res.data;
      empChart1.push(dataObj2.deactiveEmployeeCount);
      empChart1.push(dataObj2.activeEmployeeCount);
      empChart1.push(dataObj2.totalEmployeeCount);
      empChart1.push(dataObj2.lastMonthUsageCount);
      empChart1.push(dataObj2.totalUsageCount);
      setTotalEmployeeCount(empChart1);
      setTotalUsageCount(empChart1);

      setChartData({
        labels: ["Active", "Deactive"],
        datasets: [
          {
            data: [
              dataObj2.activeEmployeeCount,
              dataObj2.deactiveEmployeeCount,
            ],
            backgroundColor: ["#02c39a", "#1557c0"],
            hoverOffset: 4,
          },
        ],
      });

      setChartData2({
        labels: ["Last Month Usage Count"],
        datasets: [
          {
            data: [dataObj2.lastMonthUsageCount],
            backgroundColor: ["#788bff"],
            hoverOffset: 4,
          },
        ],
      });
    });
  };

  useEffect(() => {
    chart();
    chart2();
  }, []);

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  else {
    return (
      <>
        <div className="row bg-white rounded">
          <div className="col-12 py-4">
            <h1 className="display-4 mb-0">Dashboard</h1>
          </div>
          <Divider className="w-100" />
          <div className="col-12 pl-4 pr-4">
            <div className="row">
              <div className="col-12 d-flex flex-column align-items-center">
                <div className="w-100 pt-5 pb-3 d-flex justify-content-around flex-column">
                  <div className="w-100 d-flex justify-content-around">
                    <div className=" my-5 " style={{ width: "300px" }}>
                      <Badge style={{ backgroundColor: "#1b4965", padding: "15px", color: "#fff", fontSize: "14px", marginBottom: "20px" }}>
                        Total Employee Count: {totalEmployeeCount[2]}
                      </Badge>
                      <Pie data={chartData} options={{ responsive: true }} />


                    </div>
                    <DashboardAsset />
                  </div>

                  <div className="w-100 d-flex  justify-content-around">
                    <div className=" my-5 " style={{ width: "300px" }}>
                      <Badge style={{ backgroundColor: "#3d348b", padding: "15px", color: "#fff", fontSize: "14px", marginBottom: "20px" }}>
                        Total Usage Count: {totalUsageCount[4]}
                      </Badge>
                      <Pie data={chartData2} options={{ responsive: true }} />
                    </div>
                    <DashboardUsage />

                  </div>
                </div>
                <div className=" my-5 " style={{ width: "500px" }}>
                  <Line
                    className="LineData"
                    data={lineData}
                    options={{ responsive: true }}
                  />
                </div>
              </div>

            </div>
          </div>
        </div>
        <div className="row bg-white rounded" style={{ marginTop: "50px" }}>
          <Divider className="w-100" />
          <div className="col-12 pl-4 pr-4">
            <div className="row">
              <div className="col-12">
                <div className="w-100 pt-5 pb-3 d-flex justify-content-around">
                  <div className="w-100 my-5 ">
                    <DashboardMerchant />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
